<template>
  <div class="disclaimer">
    <div class="container">
      <h1>Disclaimer</h1>
      <div class="content">
        <p>Your disclaimer content here...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Disclaimer'
}
</script>

<style scoped>
.disclaimer {
  padding: 60px 0;
  min-height: 60vh;
}

.disclaimer h1 {
  text-align: center;
  margin-bottom: 40px;
  color: #2444CB;
}
</style>